export default __webpack_public_path__ + "static/media/yumiko_kadota.c3e93954.jpg";